module.exports = __webpack_public_path__ + "img/092-sierra-leone.d3924268.svg";